// Persistent banner shown for 72 hours after a crisis modal dismissal
// OR an SSRS level >=1 / crisis_resources_shown row in the same window.
// Snoozable for 24 h; if the 72-h predicate is still true after the
// snooze expires, the banner re-appears (Part 12 §P12.7 D4).

import { Button } from '../ui/Button';

interface CrisisBannerProps {
  onOpen: () => void;
  onSnooze: () => void;
  snoozing?: boolean;
}

export function CrisisBanner({ onOpen, onSnooze, snoozing }: CrisisBannerProps) {
  return (
    <div className="crisis-banner" role="status">
      <span className="crisis-banner-text">
        Resources for crisis support are always available.
      </span>
      <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
        <Button
          variant="tertiary"
          size="md"
          onClick={onSnooze}
          disabled={snoozing}
          style={{ color: 'var(--color-on-primary)' }}
        >
          Snooze 24h
        </Button>
        <button type="button" onClick={onOpen} className="crisis-banner-cta">
          Open
        </button>
      </div>
    </div>
  );
}
